export default {
  workflows: {
    title: 'CARTO Workflows is in General Availability 🚀',
    description:
      '<strong>CARTO Workflows</strong> is a new tool that provides a visual language to design and execute scalable multi-step spatial analytical procedures natively in your cloud data warehouse without needing to write SQL code. To learn more about this tool, please check our <link>product documentation.</link>',
    action: 'Go to Workflows'
  }
}
